import { render, staticRenderFns } from "./EquitativeServices.vue?vue&type=template&id=bdeccb80&"
import script from "./EquitativeServices.vue?vue&type=script&lang=js&"
export * from "./EquitativeServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports